import * as React from 'react';
import { Box } from '../';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import tag from 'blacklist-tag';
import { Span, Label } from '../../typography';

type FormGroupProps = StyledSystemProps & {
  id: string;
  color?: string;
  label: string;
  value: any;
  error: any;
  touched: any;
  onChange: any;
  onBlur: any;
  children: React.ReactNode;
};

const InputFeedback = ({ error }: { error: string }) =>
  (error ?
    <Span style={{ width: 'fit-content', marginLeft: 'auto', marginRight: '20px' }} color="#cc0000">{error}</Span> :
    null);

class CheckboxGroup extends React.Component<FormGroupProps, {}> {
  static defaultProps = {
    mb: 3,
    width: '100%',
    type: 'string',
    flex: 1,
    minWidth: '150px',
  };

  handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    const { value, id, onChange } = this.props;
    const target = event.currentTarget;
    let valueArray = [...value] || [];
    const index = valueArray.findIndex(x => x.label === target.id);
    if (target.checked) {
      valueArray[index].value = true;
    } else {
      valueArray[index].value = false;
    }
    onChange(id, valueArray);
  };

  handleBlur = () => {
    // take care of touched
    const { id, onBlur } = this.props;
    onBlur(id, true);
  };

  render() {
    const { value, error, touched, label, children } = this.props;
    return (
      <Box {...this.props}>
        <Label>{label}</Label>
        <Box flexWrap="wrap" flexDirection="row">
          {React.Children.map(children, (child: React.ReactElement<any>, index) => {
            if (child) {
              return React.cloneElement(child, {
                field: {
                  value: value.find((x: any) => x.label === child.props.id).value,
                  onChange: this.handleChange,
                  onBlur: this.handleBlur,
                },
              });
            }
            return null;
          })}
        </Box>
        {touched && <InputFeedback error={error} />}
      </Box>
    );
  }
}

export const CleanCheckboxGroup = tag(CheckboxGroup, [
  'name',
  'form',
  'width',
  'display',
  'alignItems',
  'flexDirection',
  'justifyContent',
]);

export default CleanCheckboxGroup;



// WEBPACK FOOTER //
// ./src/components/formElements/StyledCheckboxGroup.tsx